/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const ReportQuantityPage = lazyLoad(
  () => import('./index'),
  module => module.ReportQuantityPage
);
